module.exports = __webpack_public_path__ + "static/img/theatre_2.15e195f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/theatre_2.jpg
// module id = ga2p
// module chunks = 3